<form name="openCloseContractForm" [formGroup]="form">
  <hub-modal-form-header [title]="title" (close)="bsModalRef.hide()"></hub-modal-form-header>
  <div class="modal-body">
    {{ text }}
    <hub-modal-form-footer [saveText]="saveText" [cancelText]="cancelText" [requiredNote]="false"
      [errorMessage]="serverError" [inProgress]="saveInProgress" (submit)="onSubmit(form.value)"
      (close)="bsModalRef.hide()">
    </hub-modal-form-footer>
  </div>
</form>